import React from "react";
import { ColorPicker } from "antd";

export const STATIC_COLORS = ["#4DD0E1", "#EF5350", "#FF7043", "#42A5F5"];

export const toHexColor = (color) => {
  if (!color || typeof color !== "string") return "";
  if (color.startsWith("#")) {
    const hex = color.slice(0, 7);
    if (hex.length === 4) {
      return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`.toUpperCase();
    }
    return hex.toUpperCase();
  }
  const match = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (match) {
    return (
      "#" +
      [match[1], match[2], match[3]]
        .map((n) => Number(n).toString(16).padStart(2, "0"))
        .join("")
        .toUpperCase()
    );
  }
  return "";
};

export const isDarkColor = (color) => {
  const hex = toHexColor(color);
  if (!hex || hex.length < 7) return false;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.55;
};

export const QUICK_CHAT_COLOR_ON_DARK = "#FFFFFF";
export const QUICK_CHAT_COLOR_ON_LIGHT = "#8C8C8C";

export const getQuickChatContentColors = (backgroundColor) => {
  const color = isDarkColor(backgroundColor)
    ? QUICK_CHAT_COLOR_ON_DARK
    : QUICK_CHAT_COLOR_ON_LIGHT;
  return {
    text_color: color,
    image_color: color,
  };
};

const ColorOptions = ({ value, onChange }) => {
  const currentHex = toHexColor(value);
  const isStaticColorSelected = STATIC_COLORS.some(
    (c) => c.toUpperCase() === currentHex,
  );

  return (
    <div className="appearanceColorOptions">
      {STATIC_COLORS.map((color) => (
        <button
          type="button"
          key={color}
          className={`appearanceColorSwatch${currentHex === color.toUpperCase() ? " selected" : ""}`}
          onClick={() => onChange(color)}
          aria-label={`Select color ${color}`}
        >
          <span style={{ backgroundColor: color }} />
        </button>
      ))}
      <div
        className={`appearanceDynamicColor${currentHex && !isStaticColorSelected ? " selected" : ""}`}
      >
        <ColorPicker
          format="hex"
          defaultFormat="hex"
          value={currentHex || undefined}
          onChange={(picked, hex) => onChange(picked, hex)}
          size="small"
          showText
          style={{ fontWeight: 400 }}
        />
      </div>
    </div>
  );
};

export default ColorOptions;
